module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9peLgp/tc-custom/9781452109770.jpg?1694202044169",
      "alt": "This image is the cover for the book Boy Who Loved Batman"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Boy Who Loved Batman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The Batman movie producer reveals how his childhood love of comic books became a lifelong passion and dream job in this illustrated memoir.")]), _c('br'), _c('br'), _vm._v("Is any superhero cooler than Batman? He’s a crime-fighting vigilante with a tragic past, a lawless attitude, and a seemingly endless supply of high-tech gadgetry. In this fully illustrated memoir, author Michael Uslan recalls his journey from early childhood fandom through to the decades he spent on a caped crusade of his own: to bring Batman to the silver screen as the dark, serious character he was at heart. "), _c('br'), _c('br'), _vm._v("Uslan’s story traces his path from the wilds of New Jersey to the limelight of Hollywood, following his work as Executive Producer on every Batman film from Tim Burton’s 1989 re-envisioning to 2012’s The Dark Knight Rises. Through it all, he helped to create one of the most successful pop culture franchises of all time."), _c('br'), _c('br'), _c('b', [_vm._v("“Don’t miss this spellbinding tale of one man who saw what Batman was—and realized what he could become.” —Stan Lee")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael E. Uslan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michael Uslan is a film producer with numerous award winning projects to his credit. He is Executive Producer of all of the Batman features from Batman to The Dark Knight Rises and won an Emmy Award for TV's \"Where on Earth Is Carmen Sandiego?\" He has been a speaker at New York's Metropolitan Museum of Art, and at the Smithsonian Institution, and taught the world's first accredited college course on comic books.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0